import type { AnyObjectSchema } from 'yup';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useMemo } from 'react';

export const useFormSchema = (yupSchema: AnyObjectSchema) => {
    const schema = useMemo(() => yupSchema, [yupSchema]);

    return useForm({
        resolver: yupResolver(schema),
        mode: 'onChange'
    });
};
